import { capitalCase } from "change-case";

import { loadLocale } from "@smart/itops-locale-dom";
import { Button, ProgressCircle } from "@smart/itops-sb-design-system-dom";

export type IntakeSignaturePreparingStatusProps = {
  status: "waiting" | "failed";
};

const subHeading = {
  waiting:
    "We're preparing your document for signature. This can take up to a minute, please don't close or refresh this page.",
  failed:
    "This is taking longer than expected. If your document doesn't load, refresh the page to try again.",
};

export const IntakeSignaturePreparingStatus = ({
  status,
}: IntakeSignaturePreparingStatusProps) => (
  <div className="absolute inset-0 bg-white flex items-center justify-center">
    <div className="flex flex-col items-center text-center max-w-[45rem]">
      <ProgressCircle size="large" />
      <h1 className="text-h3 font-semibold mt-[2rem]">
        {capitalCase(loadLocale().terms.finalise.present)} your document
      </h1>
      <p className="text-ui mt-[1rem] mb-[2rem]">{subHeading[status]}</p>
      {status === "failed" && (
        <Button
          text="Refresh page"
          variant="primarySubtle"
          onClick={() => window.location.reload()}
        />
      )}
    </div>
  </div>
);
